<input
  type="text"
  class="emd-input"
  #input
  matInput
  [matAutocomplete]="auto"
  [placeholder]="placeholder"
  (input)="hasOptionSelected.next(false)"
  [formControl]="control"
/>
<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelect($event.option.value)">
  <mat-option *ngFor="let option of options" [value]="option">
    {{ option }}
  </mat-option>

  <mat-option
    *ngFor="let option of filteredOptions$ | async"
    [value]="option"
  >
    {{ option.label }}
  </mat-option>
</mat-autocomplete>
